import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';

export function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handlePlayNow = useCallback(() => {
    // Scroll to top
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // Focus on display name input after scroll
    setTimeout(() => {
      const input = document.getElementById('displayName') as HTMLInputElement;
      input?.focus();
    }, 400);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 h-16 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center justify-between">
        <div className="flex items-center">
          <Link to="/" className="text-xl font-bold text-black tracking-tight">
            Shengji
          </Link>
        </div>
        <div className="flex items-center gap-6">
          <Link
            to="/rules"
            className="text-sm font-semibold text-black hover:text-red transition-colors"
          >
            Rules
          </Link>
          <button
            onClick={handlePlayNow}
            className="text-sm font-semibold text-red hover:text-red-dark transition-colors cursor-pointer"
          >
            Play Now
          </button>
        </div>
      </div>
    </nav>
  );
}
